<footer class="py-14 relative pb-10 px-10 bg-neutral-300 border-t-2 border-yellow-primary">
    <span class="background-image" [lazyLoad]="backgroundImage"></span>
    <div class="max-w-screen-2xl mx-auto relative">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-6">
            <div>
                <h3 class="text-blue-primary font-medium text-lg">Links de interés</h3>
                <ul class="mt-3 flex flex-col gap-y-1.5 text-[15px]">
                    <li class="decoration-white">
                        <a rel="noopener"
                            href="https://d2kkzfskpa3qm4.cloudfront.net/docs/Comunicacion Actualizacion_10032023.pdf"
                            target="_blank" class="underline text-blue-primary font-medium">Actualizamos Comunicado</a>
                    </li>
                    <li class="underline decoration-white">
                        <a routerLink="/politicas-privacidad">Política de Privacidad</a>
                    </li>
                    <li class="underline decoration-white">
                        <a rel="noopener"
                            routerLink="/tyc-generales">Términos y Condiciones</a>
                    </li>
                    <li class="underline decoration-white">
                           <a routerLink="/pqr-principal">PQRS</a>
                    </li>
                    <li class="underline decoration-white">
                        <a routerLink="/medios-de-pago">Medios de pago</a>
                    </li>
                    <li class="underline decoration-white">
                        <a routerLink="/ayuda">Preguntas frecuentes</a>
                    </li>
                    <li class="underline decoration-white">
                        <a routerLink="/auth/login">Mi cuenta Rayo</a>
                    </li>
                    <li class="underline decoration-white">
                        <a rel="noopener"
                            href="https://www.superfinanciera.gov.co/"
                            target="_blank">Regulación de Tasas</a>
                    </li>
                    <li class="underline decoration-white">
                        <a rel="noopener"
                            href="https://front-colombia.s3.us-east-2.amazonaws.com/docs/TYC+-+06-+2026/POL%C3%8DTICAS_COBRANZA_RAYO_v2.pdf"
                            target="_blank">Política de Cobranzas</a>
                    </li>
                    <li class="underline decoration-white">
                        <a routerLink="/cobranzas-externas">Cobranzas Externas Autorizadas</a>
                    </li>
                    <li class="underline decoration-white">
                        <a routerLink="/campanas" class="font-medium text-blue-primary">Términos y Condiciones de
                            Campañas</a>
                        <span
                            class="inline-flex justify-center animate-pulse items-center bg-blue-primary text-xs ml-1.5 font-medium rounded text-white px-2 py-0.5 no-underline">
                            ¡Nuevo!
                            <i class="bi bi-lightning-charge-fill text-yellow-primary"></i>
                        </span>
                    </li>
                    <li class="underline decoration-white">
                        <a routerLink="/politicas-web-app" class="font-medium text-blue-primary">Políticas de Privacidad
                            Web/App Rayo</a>
                        <span
                            class="inline-flex justify-center animate-pulse items-center bg-blue-primary text-xs ml-1.5 font-medium rounded text-white px-2 py-0.5 no-underline">
                            ¡Nuevo!
                            <i class="bi bi-lightning-charge-fill text-yellow-primary"></i>
                        </span>
                    </li>
                </ul>
            </div>
            <div>
                <div>
                    <h4 class="text-blue-primary font-medium text-lg">Países</h4>
                    <ul class="mt-3 flex flex-col gap-y-1.5 text-[15px]">
                        <li class="underline decoration-white">
                            <a rel="noopener" href="https://rayo.cr" target="_blank">Rayo Costa Rica</a>
                        </li>
                        <li class="underline decoration-white">
                            <a rel="noopener" href="https://rayocredit.com/mx/" target="_blank">Rayo México</a>
                        </li>
                        <li class="underline decoration-white">
                            <a href="https://rayocredit.com/co/">Rayo Colombia</a>
                        </li>
                    </ul>
                    <div class="mt-10">
                        <a rel="noopener" href="https://sedeelectronica.sic.gov.co/" target="_blank">
                            <img src="https://d2kkzfskpa3qm4.cloudfront.net/imagenes/industria-y-comercio.webp"
                                 width="200" height="54" alt="industria-comercio" loading="lazy" decoding="async">
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <h4 class="text-blue-primary font-medium text-lg">Contáctanos</h4>
                    <ul class="flex flex-col gap-y-1.5 text-[15px]">
                        <li class="cursor-pointer">
                            <div class="flex items-center gap-4">
                                <i class="bi-whatsapp text-2xl text-blue-primary font-medium"></i>
                                <a rel="noopener" href="https://wa.link/je7i2m" target="_blank"
                                    class="underline decoration-white font-bold">316 919 7373</a>
                            </div>
                            <p class="ml-6 mt-1 text-sm">Te acompañamos con:</p>
                            <ul class="ml-6 list-item list-disc mt-1">
                                <li>Préstamos en línea</li>
                                <li>Renovación de tu préstamo</li>
                                <li>Gestión de cobros</li>
                                <li>Atención al cliente</li>
                            </ul>
                        </li>
                        <li class="cursor-pointer mt-1.5">
                            <div class="flex items-center gap-4">
                                <i class="bi-headphones text-2xl text-blue-primary font-medium"></i>
                                <a href="tel:+573103158650" class="underline decoration-white">310 315 8650</a>
                            </div>
                            <p class="ml-6 mt-1 text-sm">Te ayudamos con:</p>
                            <ul class="ml-6 list-item list-disc mt-1">
                                <li>Préstamos en línea</li>
                                <li>Renovación de tu préstamo</li>
                                <li>Gestión de cobros</li>
                                <li>Atención al cliente</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <br>
                <div class="flex items-center gap-4">
                           <i class="bi bi-mailbox-flag text-2xl text-blue-primary font-medium"></i>
                    <a  class="underline decoration-white">info&#64;rayo.com.co</a>
                </div>
                <div class="mt-5">
                    <h4 class="text-blue-primary font-medium text-lg">Síguenos en</h4>
                    <div class="mt-3 flex gap-x-5">
                        <a rel="noopener" href="https://www.facebook.com/RayoBogota/" title="Follow on Facebook"
                            target="_blank">
                            <i class="bi-facebook text-lg text-blue-primary font-medium"></i>
                        </a>
                        <a rel="noopener" href="https://www.instagram.com/rayo_col/" title="Follow on Instagram"
                            target="_blank">
                            <i class="bi-instagram text-lg text-blue-primary font-medium"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <h4 class="text-blue-primary font-medium">Ejemplo préstamo!</h4>
                <div class="mt-3">
                    <ul class="text-sm">
                        <li class="list-disc list-inside">Mínimo y máximo plazo de pago: 60 a 360 días.</li>
                        <li class="list-disc list-inside">Tasa de Interés Anual máxima: {{ porcentaje_tasa }} EA. La
                            tasa máxima
                            permitida de {{ porcentaje_tasa }} dependerá de la fecha de otorgación del crédito.</li>
                        <li class="list-disc list-inside">Servicio de tecnología dependerá del plazo y tipo de préstamo.
                        </li>
                    </ul>
                    <div class="text-sm mt-3">
                        <p><span class="font-medium">Ejemplo préstamo a 3 cuotas:</span> Valor a solicitar: $1,000,000
                        </p>
                        <ul class="mt-2 flex flex-col gap-y-1.5">
                            <li class="list-disc list-inside">Interés: $33,795</li>
                            <li class="list-disc list-inside">Tecnología: $174,500</li>
                            <li class="list-disc list-inside">IVA: 33,155</li>
                            <li class="list-disc list-inside">Total a pagar: $1,241,450 (3 cuotas de $413,817)</li>
                        </ul>
                        <p class="mt-2"><span class="text-neutral-800 font-medium">*</span> Si incurres en mora, se
                            aplicará la tasa del {{ porcentaje_tasa }} EA sobre el valor en mora. Por ejemplo, si
                            alcanza una mora de 15 días sobre un valor de $1.000.000, el valor de intereses de mora será
                            $11.265 más los gastos de cobranza que apliquen según T&C.</p>
                    </div>
                </div>
            </div>
        </div>
        <hr class="mt-5 mb-2">
        <div class="text-center flex flex-col pointer-events-none select-none">
            <span class="text-sm font-medium text-blue-hover">Carrera 11ª Nº 94ª 23</span>
            <span class="text-sm font-medium text-blue-hover mt-1">Copyright &copy; 2026 &middot; RAYOCR COLOMBIA RFC RME211021L2A. All Rights Reserved.</span>
            <span class="mt-1 text-blue-hover font-semibold">RAYCOL S.A.S N.I.T. 901287068-0</span>
        </div>
    </div>
</footer>
